import VSelectInvoiceClass from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectInvoiceClass', VSelectInvoiceClass),
};
